import React, { useEffect, useRef } from 'react';
import { BackgroundContainer } from './background-styles';
import { isServer } from '../../utils';
var lazyBackgroundObserver;
if (!isServer && 'IntersectionObserver' in window) {
    lazyBackgroundObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                lazyBackgroundObserver.unobserve(entry.target);
            }
        });
    });
}
var Background = function (_a) {
    var baseImageSource = _a.baseImageSource, imageSourceSet = _a.imageSourceSet, lazyLoad = _a.lazyLoad, children = _a.children;
    var _containerRef = useRef(null);
    useEffect(function () {
        var target = _containerRef.current;
        if (lazyLoad && target) {
            lazyBackgroundObserver === null || lazyBackgroundObserver === void 0 ? void 0 : lazyBackgroundObserver.observe(target);
            return function () {
                lazyBackgroundObserver === null || lazyBackgroundObserver === void 0 ? void 0 : lazyBackgroundObserver.unobserve(target);
            };
        }
    }, [lazyLoad]);
    return (React.createElement(BackgroundContainer, { ref: _containerRef, baseImageSource: baseImageSource, imageSourceSet: imageSourceSet, lazyLoad: lazyLoad }, children));
};
export default Background;
